import { useNotificationsStore } from '@/stores/notifications/notifications.store';

export default function userMention(): void {
  const notificationsStore = useNotificationsStore();

  notificationsStore.increaseNotificationsNumber();
}
